import { create } from "zustand";
import type { DocID } from "@/types";

type ChatTagFilterState = {
  selectedTagIds: Set<DocID>;
  toggleTag: (tagId: DocID) => void;
  clearTags: () => void;
};

export const useChatTagFilter = create<ChatTagFilterState>((set) => ({
  selectedTagIds: new Set<DocID>(),
  toggleTag: (tagId) =>
    set((state) => {
      const next = new Set(state.selectedTagIds);
      if (next.has(tagId)) {
        next.delete(tagId);
      } else {
        next.add(tagId);
      }
      return { ...state, selectedTagIds: next };
    }),
  clearTags: () =>
    set((state) => ({ ...state, selectedTagIds: new Set<DocID>() })),
}));
